// @core/api/endpoints/payment/update_payment_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdatePaymentProviderRequest,
  UpdatePaymentProviderResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Update payment provider
 * Updates provider configuration, credentials, or status.
 */
export async function UpdatePaymentProvider(
  id: string,
  data: UpdatePaymentProviderRequest,
  options?: RequestOptions
): Promise<UpdatePaymentProviderResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-providers/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.patch<UpdatePaymentProviderResponse>(requestPath, data, requestOptions);
}
